var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupplier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Nav / Supplier / no notification") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Nav-/-Supplier-/-no-notification"
  }, /*#__PURE__*/React.createElement("g", {
    id: "purchase",
    transform: "translate(19.000000, 25.000000)",
    stroke: "#3C434D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "van",
    transform: "translate(0.500000, 0.500000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Line",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "2.5 13.5 0.5 13.5 0.5 0.5 18.5 0.5 21.5 6.5 24.5 8.5 24.5 13.5 22.5 13.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,13.5 L11.5,13.5",
    id: "Line",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 5,
    y: 13,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 16,
    y: 13,
    width: 4,
    height: 4,
    rx: 2
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Spacer-square",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplier);
export default __webpack_public_path__ + "static/media/Supplier.91d972b67320eb9c350e0408182254f1.svg";
export { ForwardRef as ReactComponent };